var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-outer",class:{'-small': _vm.size === 'small'},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"button-inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }